module.exports = __webpack_public_path__ + "assets/img/logo-black.a764a95e.png";